"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAppVersionListResponseDto = instanceOfAppVersionListResponseDto;
exports.AppVersionListResponseDtoFromJSON = AppVersionListResponseDtoFromJSON;
exports.AppVersionListResponseDtoFromJSONTyped = AppVersionListResponseDtoFromJSONTyped;
exports.AppVersionListResponseDtoToJSON = AppVersionListResponseDtoToJSON;
exports.AppVersionListResponseDtoToJSONTyped = AppVersionListResponseDtoToJSONTyped;
var AppVersionDto_1 = require("./AppVersionDto");
/**
 * Check if a given object implements the AppVersionListResponseDto interface.
 */
function instanceOfAppVersionListResponseDto(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function AppVersionListResponseDtoFromJSON(json) {
    return AppVersionListResponseDtoFromJSONTyped(json, false);
}
function AppVersionListResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'status': json['status'],
        'message': json['message'],
        'data': json['data'] == null ? undefined : (json['data'].map(AppVersionDto_1.AppVersionDtoFromJSON)),
        'error': json['error'] == null ? undefined : json['error'],
        'meta': json['meta'] == null ? undefined : json['meta'],
        'traceId': json['traceId'] == null ? undefined : json['traceId'],
    };
}
function AppVersionListResponseDtoToJSON(json) {
    return AppVersionListResponseDtoToJSONTyped(json, false);
}
function AppVersionListResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'statusCode': value['statusCode'],
        'status': value['status'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : (value['data'].map(AppVersionDto_1.AppVersionDtoToJSON)),
        'error': value['error'],
        'meta': value['meta'],
        'traceId': value['traceId'],
    };
}
